import { GmailIcon, WhatsAppIcon } from "../../components/Icons";
import { useContact } from "../../data/content";

// The address used to be assembled from string fragments to dodge scrapers.
// It now arrives over the network at runtime and is never in the bundle at all,
// which does the same job better.
function ContactInfo() {
  const { email, phone, phoneDisplay } = useContact();

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mt-10">
      {email && (
        <a
          href={`mailto:${email}`}
          className="flex items-center gap-2.5 text-text-muted-light dark:text-text-muted-dark hover:text-text-primary-light dark:hover:text-text-primary-dark transition-colors duration-200"
        >
          <GmailIcon size={20} />
          <span className="font-sans text-sm">{email}</span>
        </a>
      )}

      {email && phone && (
        <div className="hidden sm:block w-px h-4 bg-border-light dark:bg-border-dark" />
      )}

      {phone && (
        <a
          href={`https://wa.me/${phone}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2.5 text-text-muted-light dark:text-text-muted-dark hover:text-text-primary-light dark:hover:text-text-primary-dark transition-colors duration-200"
        >
          <WhatsAppIcon size={22} />
          <span className="font-sans text-sm whitespace-nowrap">{phoneDisplay || phone}</span>
        </a>
      )}
    </div>
  );
}

export default ContactInfo;
